module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/AtencionPrint.b6f6ab7d.svg";